import { getSpacing } from '@harver/shared-ui';

export enum LayoutZIndex {
    Main = 1,
    Header = 2,
    HeaderPortal = 3,
}

export const headerHeightMobileFactor = 14;
export const headerHeightDesktopFactor = 18;
export const headerHeightMobile = getSpacing(headerHeightMobileFactor);
export const headerHeightDesktop = getSpacing(headerHeightDesktopFactor);
export const layoutMaxWidthDesktop = '1280px';
